import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import Header from "../components/Header";
import Footer from "../components/Footer";
import FloatingContact from "../components/FloatingContact";
import ApplicationDialog from "../components/ApplicationDialog";
import alinaBanner from "../assets/webinar/alina-banner.webp";
import { useLang } from "../i18n/LangContext";
import { getWebinarT } from "../i18n/webinar_i18n";
import { RegisterForm } from "./WebinarPage";

const WebinarStudygriPage = () => {
  const { lang } = useLang();
  const w = getWebinarT(lang);
  const [formOpen, setFormOpen] = useState(false);
  const rtl = lang === 'ar';

  return (
    <div className="min-h-screen" style={{ background: '#1B2A4A' }} dir={rtl ? 'rtl' : 'ltr'}>
      <Helmet>
        <title>{`${w.h1} — STUDYGRI`}</title>
        <meta name="description" content={w.subtitle} />
      </Helmet>

      <Header onOpenForm={() => setFormOpen(true)} />

      <main className="pt-24 md:pt-32 pb-16" data-testid="webinar-studygri-page">
        <section className="px-4 md:px-8 py-8 md:py-14">
          <div className="max-w-[1500px] mx-auto grid md:grid-cols-[1fr,1.35fr] gap-8 md:gap-10 items-center">

            {/* LEFT: registration form */}
            <div id="webinar-register" className="order-2 md:order-1 rounded-3xl p-6 md:p-8 lg:p-10" style={{ background: '#fff', boxShadow: '0 25px 60px -20px rgba(0,0,0,0.35)' }}>
              <h2 className="font-display text-2xl md:text-3xl lg:text-4xl leading-tight" style={{ color: '#1B2A4A', fontWeight: 900, letterSpacing: '-0.02em' }}>
                {w.regTitle}
              </h2>
              <p className="mt-2 text-sm md:text-base" style={{ color: '#666' }}>{w.regDesc}</p>
              <div className="mt-6"><RegisterForm /></div>
            </div>

            {/* RIGHT: banner */}
            <div className="order-1 md:order-2 flex justify-center md:justify-end">
              <div
                className="w-full rounded-3xl overflow-hidden"
                style={{ boxShadow: '0 30px 80px -20px rgba(0,0,0,0.6)', border: '3px solid #C9A96E' }}
                data-testid="webinarstudygri-banner"
              >
                <img
                  src={alinaBanner}
                  alt={w.speakerCaption || 'Онлайн-вебінар STUDYGRI: Вступ за кордон'}
                  className="w-full h-auto block"
                />
              </div>
            </div>

          </div>
        </section>
      </main>

      <Footer />
      <FloatingContact onOpenForm={() => setFormOpen(true)} />
      <ApplicationDialog open={formOpen} onOpenChange={setFormOpen} />
    </div>
  );
};

export default WebinarStudygriPage;
